<template>
  <div class="main-wrap">
    <div class="row justify-content-md-center text-align-left">
      <div class="col-md-6 text-left">
        <div class="col">
          <button
            class="btn btn-grey btn-year"
            v-for="item in years"
            :key="item.year"
            :class="{ selyear: item.selected }"
            @click="filterTransactions(item.year)"
          >
            {{ item.year }}
          </button>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-md-center text-align-center"
      v-if="!menuVisible"
    >
      <div class="col-6">
        <div class="col order-details">
          <p
            class="trans-head"
            style="background: #ff607f; color: white; background-color: #ff607f"
          >
            Transaction History ({{ history.length }})
          </p>
        </div>
        <div class="order-items col">
          <div class="table" v-if="history.length">
            <table>
              <thead>
                <tr>
                  <th>Order ID</th>
                  <th class="text-right">Order Total</th>
                  <th class="text-right">Order Processed</th>
                  <th class="text-right">Order Date</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in history" :key="item.tranid">
                  <td>
                    <a
                      @click="getSingleTransaction(item.tranid)"
                      class="blue-a"
                      >{{ item.tranid }}</a
                    >
                  </td>

                  <td class="text-right">
                    {{ item.tranTotalCharge | currency }}
                  </td>
                  <td class="text-right">
                    <i class="far fa-check" v-if="item.tranProcessed"></i>
                    <i class="far fa-times" v-if="!item.tranProcessed"></i>
                  </td>
                  <td class="text-right">
                    {{ item.tranPostedDate | date }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-md-center text-align-center"
      v-if="menuVisible"
    >
      <div class="col-6">
        <div class="col order-details">
          <p
            class="trans-head"
            style="background: #ff607f; color: white; background-color: #ff607f"
          >
            <a @click="menuVisible = false"
              ><i class="far fa-angle-left"></i
            ></a>
            Transaction # {{ tranId }}
          </p>
          <p v-if="!transaction.length" class="nodata">
            No Transaction Details Available
          </p>
          <!-- order items  -->
          <div class="table" v-if="orderitems.length">
            <table>
              <thead>
                <tr>
                  <th class="text-left">Order Item Description</th>
                  <th class="text-left">Info</th>
                  <th class="text-right">Price</th>
                  <th class="text-right">Quantity</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in orderitems" :key="index">
                  <td class="text-left">
                    {{ item.description }}
                  </td>

                  <td class="text-left">
                    {{ item.notes }}
                  </td>
                  <td class="text-right">
                    {{ item.price | currency }}
                  </td>
                  <td class="text-right">
                    {{ item.quantity }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- shippings baskets -->
          <div class="table" v-if="baskets.length">
            <table>
              <thead>
                <tr>
                  <th class="text-left">Shipping Basket</th>
                  <th class="text-left">Info</th>
                  <th class="text-right">Price</th>
                  <th class="text-right">Quantity</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in baskets" :key="index">
                  <td class="text-left">
                    {{ item.description }}
                  </td>

                  <td class="text-left">
                    {{ item.Notes }}
                  </td>
                  <td class="text-right">
                    {{ item.price | currency }}
                  </td>
                  <td class="text-right">
                    {{ item.quantity }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--  members list  -->
          <div class="table" v-if="shaliah.length">
            <table>
              <thead>
                <tr>
                  <th class="text-left">Members List</th>
                  <th class="text-left">Info</th>
                  <th class="text-right">Price</th>
                  <th class="text-right">Quantity</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(item, index) in shaliah" :key="index">
                  <td class="text-left">
                    {{ item.description }}
                  </td>

                  <td class="text-left">
                    {{ item.Notes }}
                  </td>
                  <td class="text-right">
                    {{ item.price | currency }}
                  </td>
                  <td class="text-right">
                    {{ item.quantity }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import currencyFilter from "../shared/currency-filter";
import dateFilter from "../shared/date";

import VueHtmlToPaper from "vue-html-to-paper";
import $ from "jquery";

export default {
  name: "TranHistoryPage",
  filters: {
    currency: currencyFilter,
    date: dateFilter,
  },
  data: function() {
    return {
      years: [{ year: "All", selected: true }],
      selFilter: "All",
      menuVisible: false,
      tranid: 0,
      orderitems: [],
      shaliah: [],
      baskets: [],
    };
  },

  computed: {
    history() {
      let d = this.$store.state.transactions;
      for (let i = 0; i < d.length; i++) {
        let y = moment(d[i].tranPostedDate).format("yyyy");
        let f_y = this.years.filter((a) => a.year === y);
        if (!f_y.length) {
          this.years.push({ year: y, selected: false });
        }
      }
      if (this.selFilter !== "All") {
        let obj = d.filter(
          (a) => moment(a.tranPostedDate).format("yyyy") === this.selFilter
        );
        d = obj;
      }
      console.log("this.years ", this.years, this.selFilter, d);
      return d;
    },
    transaction() {
      let t = this.$store.state.transaction;
      this.orderitems = [];
      this.shaliah = [];
      this.baskets = [];

      for (let i = 0; i < t.length; i++) {
        if (t[i].itemType === "Order Items") {
          this.orderitems.push(t[i]);
        } else if (t[i].itemType === "Shipping Baskets") {
          this.baskets.push(t[i]);
        } else if (t[i].itemType === "Members") {
          this.shaliah.push(t[i]);
        }
      }
      console.log("this.shaliah ", this.shaliah);
      return this.$store.state.transaction;
    },
  },
  methods: {
    toggleMenu(id) {
      this.tranId = id;
      this.menuVisible = !this.menuVisible;
      this.orderitems = [];
      this.shaliah = [];
      this.baskets = [];
    },

    async getSingleTransaction(id) {
      await this.$store.dispatch("getSingleTransaction", id);
      this.toggleMenu(id);
    },
    filterTransactions(year) {
      this.selFilter = year;
      for (let i = 0; i < this.years.length; i++) {
        if (this.years[i].year === year) {
          this.years[i].selected = true;
        } else {
          this.years[i].selected = false;
        }
      }
      this.menuVisible = false;
    },
  },
  async created() {
    window.scrollTo(0, 0);
    await this.$store.dispatch("getTransactions");
  },
  mounted() {},
};
</script>
<style scoped>
.main-wrap {
  padding: 3em 2em;
}
.fa-check {
  font-size: 1.5em;
  color: #4bbe56;
}
.fa-times {
  font-size: 1.5em;
  color: red;
}
h1 {
  color: #ff607f;
  font-weight: 600;
  text-align: center;
}
.order-time {
  float: right;
  font-size: 0.8em;
}
.table {
  border: 1px solid #f1f0f0;
}
.text-align-center {
  text-align: center;
}
.disc {
  background: #f1f0f0;
  font-weight: 600;
}
.disc-t {
  color: #4bbe56;
}
.p-details {
  padding: 0.5em 1em;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 0;
  font-weight: 600;
  background: #f1f0f0;
}
.trans-head {
  margin: 2em 0 0;
  padding: 1em;
  text-align: left;
  background: #ff607f;
  color: #fff;
  font-size: 1.2em;
  font-weight: 500;
}
.order-d-header {
  font-size: 1.5em;
  font-weight: 600;
  margin-top: 2em;
  padding-bottom: 1em;
  border-bottom: 3px solid #ff607f;
}
.table_compact td {
  padding: 0.25rem 0.75rem;
  font-size: 0.8em;
}
.total {
  background: #ff607f;
  color: #fff;
  font-size: 1.2em;
  font-weight: 600;
}
.email-wrap {
  display: inline-block;
  width: 70%;
}
.icon-wrap {
  font-size: 50px;
  padding: 10px;
  color: #ff607f;
}
.email_wrap h1 {
  font-size: 21px;
}
.reciprocity {
  padding: 1em 1em 0;
  font-size: 18px;
  font-weight: 600;
}

.table_compact td {
  padding: 0.25rem 0.75rem;
  font-size: 0.8em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.paylater {
  padding: 1em;
  border: 2px solid #ff607f;
  margin-top: 1em;
}
.text-right {
  padding-right: 1.5em;
}
.btn-grey {
  padding: 0.5em !important;
  min-height: 20px;
  margin: 0 0.3em 0.3em;
  min-width: 100px !important;
}
.selyear {
  background: #ff607f !important;
}
.fa-angle-left {
  color: #fff;
  padding-right: 1em;
  font-size: 1.2em;
}
.nodata {
  background-color: rgb(241, 240, 240);
  padding: 1em;
  font-weight: 600;
}
.blue-a {
  color: #ff607f !important;
  font-weight: 600;
  text-decoration: underline !important;
}
</style>
